import {
  EMPLOYEE_ROLE_PAGE_REQUEST,
  EMPLOYEE_ROLE_ON_CLICK_ROW,
  EMPLOYEE_ROLE_ON_CLICK_NEW_ROLE,
  EMPLOYEE_ROLES_REQUEST,
  EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN,
  EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN,
  EMPLOYEE_ROLE_SET_ROLES,
  EMPLOYEE_ROLE_SET_ROLE_DETAIL,
  EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS,
  EMPLOYEE_ROLE_SUBMIT_FORM_CREATE,
  EMPLOYEE_ROLE_SUBMIT_FORM_UPDATE,
  EMPLOYEE_ROLE_IS_SUBMITTING_FORM,
  EMPLOYEE_ROLE_DELETE,
  EMPLOYEE_ROLE_SET_ERROR,
} from './constants';

export function pageRequest(userId) {
  return { type: EMPLOYEE_ROLE_PAGE_REQUEST, payload: { userId } };
}

export function onClickRow(role) {
  return { type: EMPLOYEE_ROLE_ON_CLICK_ROW, payload: { role } };
}

export function onClickNewRole(data) {
  return { type: EMPLOYEE_ROLE_ON_CLICK_NEW_ROLE, payload: { data } };
}

export function rolesRequest(query, previousRoles) {
  return { type: EMPLOYEE_ROLES_REQUEST, payload: { query, previousRoles } };
}

export function openRightColumn() {
  return { type: EMPLOYEE_ROLE_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: EMPLOYEE_ROLE_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function setRoles(roles) {
  return { type: EMPLOYEE_ROLE_SET_ROLES, payload: { roles } };
}

export function setError(error) {
  return { type: EMPLOYEE_ROLE_SET_ERROR, payload: { error } };
}

export function setAssignablePermissions(permissions) {
  return {
    type: EMPLOYEE_ROLE_SET_ASSIGNABLE_PERMISSIONS,
    payload: { permissions },
  };
}

export function setRoleDetail(role) {
  return { type: EMPLOYEE_ROLE_SET_ROLE_DETAIL, payload: { role } };
}

export function deleteRole(roleId, previousRoles) {
  return { type: EMPLOYEE_ROLE_DELETE, payload: { roleId, previousRoles } };
}

export function submitFormCreate(data, previousRoles) {
  return {
    type: EMPLOYEE_ROLE_SUBMIT_FORM_CREATE,
    payload: { data, previousRoles },
  };
}

export function submitFormUpdate(data, previousRoles) {
  return {
    type: EMPLOYEE_ROLE_SUBMIT_FORM_UPDATE,
    payload: { data, previousRoles },
  };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: EMPLOYEE_ROLE_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}
